/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PageStringSection } from "./pageStringSection";

export class ForgotCredentials extends PageStringSection {
    button_resend_label: string = "Labels.lbl_Resend";
    button_send_label: string = "Labels.lbl_Send";
    button_signIn_label: string = "Labels.lbl_SignIn";
    formItem_emailAddress_label: string = "Labels.lbl_EmailAddress";
    formItem_emailAddress_placeholder: string = "Labels.lbl_EmailAddress";
    heading_checkYourEmail: string = "Labels.lbl_CheckYourEmail";
    heading_forgotCredentials: string = "Messages.msg_AccountForgotCredentials_q";
    heading_setYouPassword: string = "Messages.msg_SetYourPassword";
    text_checkSpamFolder: string = "Messages.msg_CheckSpamFolder";
    text_emailSent: string = "Messages.msg_SentInstructionsToResetPassword";
    text_forgotCredentialsDescription: string = "Messages.msg_EnterEmailToReceiveResetEmail";
    text_seconds: string = "Labels.lbl_Seconds";
    text_setYouPasswordDescription: string = "Messages.msg_EnterEmailToReceiveSetEmail";
    text_setYouPasswordEmailSent: string = "Messages.msg_SentInstructionsToSetPassword";
}
